module.exports = __webpack_public_path__ + "static/media/right-leaf-signup.09f56dc5.webp";